<template>
	<div id="site-footer" class="flex-shrink-0 mt-auto bg-siteGreen-2">
		<a href="https://api.whatsapp.com/send?phone=6596245241" id="wa-btn" class="hover:!bg-siteGreen duration-200" target="_blank">
			<img src="@/assets/images/whatsapp.png" alt="WhatsApp" class="mt-4 mx-auto" width="28" height="28">
		</a>


	</div>
</template>

<script>
export default {

}
</script>

<style>
	#wa-btn {
		position: fixed;
		width: 60px;
		height: 60px;
		bottom: 40px;
		right: 40px;
		background-color: #25d366;
		color: #FFF;
		border-radius: 50px;
		text-align: center;
		font-size: 30px;
		box-shadow: 2px 2px 3px #999;
		z-index: 100;
	}
</style>
